export default "/images/checkmark.png?24072968d46264a97c58887bf97029b2";